module.exports = __webpack_public_path__ + "assets/img/icon1.1b05351b.png";